import React, { useContext, useEffect, useState } from 'react'
import classNames from 'classnames'
import { useParams } from 'react-router-dom'
import { Form } from 'react-bootstrap'
import { plans, useErrorService } from '@abroad/components'
import TargetInfoModal from './TargetInfoModal'
import ActivePromo from './ActivePromo'
import { OrgEcoIdsContext } from '../../utils/contexts'
import labels from '../../constants/labels'
import API from '../../utils/API'

const TargetPlanDropdown = ({
  wrapperClasses = '',
  formGroupClasses = '',
  selectionClasses = '',
  disabled = false,
  setIsAnyModalEventOccurs = () => {},
}) => {
  const [isPlanChangeLoading, setIsPlanChangeLoading] = useState(false)
  const { setIsCsvUploaded, companyAndEcoInfo, setCompanyAndEcoInfo } =
    useContext(OrgEcoIdsContext)
  const { ecoSystemName } = useParams()
  const [plan, setPlan] = useState(
    companyAndEcoInfo?.targetPlan || plans.free.code,
  )
  const [showModal, setShowModal] = useState(false)
  const Error = useErrorService()

  useEffect(() => {
    if (ecoSystemName && companyAndEcoInfo) {
      getCompanyEcoCode()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ecoSystemName, companyAndEcoInfo])

  useEffect(() => {
    if (showModal) {
      setIsAnyModalEventOccurs(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showModal])

  const getCompanyEcoCode = async () => {
    try {
      setIsPlanChangeLoading(true)
      setIsCsvUploaded({
        showRosterUI:
          !companyAndEcoInfo?.isCsvUploaded &&
          companyAndEcoInfo?.usersCount === 0,
        showBtn: companyAndEcoInfo?.usersCount > 0, // companyAndEcoInfo?.isCsvUploaded && companyAndEcoInfo?.usersCount > 0
      })
      setPlan(
        companyAndEcoInfo?.targetPlan ? companyAndEcoInfo?.targetPlan : 'null',
      )
      setIsPlanChangeLoading(false)
    } catch (e) {
      setIsPlanChangeLoading(false)
      Error.showError(e)
    }
  }

  const updateTargetPlanHandler = async (newTargetPlan) => {
    setIsPlanChangeLoading(true)
    try {
      const { status } =
        await API.AdminAPI.entityService.updateNetworkEntityProgramData(
          'network',
          companyAndEcoInfo?._id,
          {
            targetPlan: newTargetPlan,
            isProgram: companyAndEcoInfo?.isProgram || false,
          },
        )
      if (status) {
        setCompanyAndEcoInfo((prev) => ({
          ...prev,
          targetPlan: newTargetPlan,
          ...(newTargetPlan === plans.free.code && { networkPromo: null }),
        }))
        setPlan(newTargetPlan)
        setIsPlanChangeLoading(false)
      }
    } catch (e) {
      Error.showError(e)
      setIsPlanChangeLoading(false)
    }
  }

  // const renderInfoIcon = () => {
  //   return (
  //     <InformationIcon
  //       onClick={() => setShowModal(true)}
  //       iconClasses='align-self-center ml-2'
  //     />
  //   )
  // }

  return (
    <>
      <TargetInfoModal
        showModal={showModal}
        onHide={() => {
          setIsAnyModalEventOccurs(false)
          setShowModal(false)
        }}
      />
      <div className={wrapperClasses}>
        <Form.Group className={formGroupClasses}>
          <Form.Label className='custom-mb-0-625 text-uppercase sidebar-label d-flex align-items-end'>
            Target Plan
          </Form.Label>
          <Form.Control
            as='select'
            name='targetPlan'
            className={classNames(
              'text-uppercase',
              {
                'pointer-cursor': !isPlanChangeLoading && !disabled,
              },
              selectionClasses,
            )}
            size='md'
            value={plan}
            onChange={(e) => {
              updateTargetPlanHandler(e.target.value)
            }}
            disabled={isPlanChangeLoading || disabled}>
            {labels.plans.map((option) => (
              <option key={option?.value} value={option?.value}>
                {option?.label}
              </option>
            ))}
          </Form.Control>
          {isPlanChangeLoading && <span className='s7 mt-2'>Updating...</span>}
        </Form.Group>
        <ActivePromo
          plan={plan}
          disabled={isPlanChangeLoading || plan === plans.free.code || disabled}
          wrapperClasses={wrapperClasses}
        />
      </div>
    </>
  )
}

export default TargetPlanDropdown
